import Link from 'next/link';
import { memo, type ReactNode } from 'react';

import { AirIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { PublicSignUpButton } from '~/components/PublicSignUpButton';
import { Routes } from '~/constants/routes';
import { usePublicCustomColors } from '~/hooks/usePublicCustomColors';
import { useShowPublicAirLogo } from '~/hooks/useShowPublicAirLogo';
import { useShowPublicSignUpButton } from '~/hooks/useShowPublicSignUpButton';

export type PublicBoardTopBarProps = {
  workspaceInfo?: ReactNode;
  accountInfo?: ReactNode;
};

export const PUBLIC_TOP_BAR_HEIGHT = 56;

export const PublicTopBar = memo(({ workspaceInfo, accountInfo }: PublicBoardTopBarProps) => {
  const { showAirLogo } = useShowPublicAirLogo();
  const { showSignUpButton } = useShowPublicSignUpButton();
  const { headerBgColor, headerForegroundColor } = usePublicCustomColors();

  return (
    <div
      className="relative flex h-14 items-center justify-between ads:bg-ads-gray-4 bg-gray-4 px-3"
      data-testid="PUBLIC_TOP_BAR"
      style={headerBgColor ? { backgroundColor: headerBgColor } : undefined}
    >
      <div>{workspaceInfo}</div>

      <div className="flex items-center gap-4">
        {accountInfo
          ? accountInfo
          : showSignUpButton && (
              <PublicSignUpButton style={headerForegroundColor ? { color: headerForegroundColor } : undefined} />
            )}
        {showAirLogo && (
          <Link aria-label="Air home" href={Routes.root}>
            <AirIcon
              className={cn('w-12', !headerForegroundColor && 'text-black dark:text-white')}
              data-testid="PUBLIC_TOP_BAR_LOGO"
              style={headerForegroundColor ? { color: headerForegroundColor } : undefined}
            />
          </Link>
        )}
      </div>
    </div>
  );
});

PublicTopBar.displayName = 'PublicTopBar';
